import { render, staticRenderFns } from "./PhonePrefixSelect.vue?vue&type=template&id=3c6e89ec&lang=pug&"
import script from "./PhonePrefixSelect.vue?vue&type=script&lang=js&"
export * from "./PhonePrefixSelect.vue?vue&type=script&lang=js&"
import style0 from "./PhonePrefixSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports